import styled from 'styled-components';

import { ButtonProps } from './types';

export const ButtonBase = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-family: ${({ theme }) => theme.fonts.title};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  outline: none;
  border: none;
  transition: all ${({ theme }) => theme.transitions.base};
  white-space: nowrap;

  &:focus,
  &:hover {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Button = styled(ButtonBase)<ButtonProps>`
  width: 100%;
  height: 2.75rem;
  padding: 0 1.5rem;
  color: #ffffff;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.sizes.borderRadius};
  letter-spacing: 0.3px;
  box-shadow: ${({ theme }) => theme.shadows.sm};

  &:not(:disabled):hover {
    background-color: ${({ theme }) => theme.colors.primaryHover};
    box-shadow: ${({ theme }) => theme.shadows.md};
    transform: translateY(-1px);
  }

  &:not(:disabled):active {
    transform: translateY(0);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }
`;

export const IconButton = styled(ButtonBase)`
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.sizes.borderRadius};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.textMuted};

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
    color: ${({ theme }) => theme.colors.title};
  }
`;

export const OutlineButton = styled(ButtonBase)<ButtonProps>`
  width: 100%;
  height: 2.75rem;
  padding: 0 1.5rem;
  color: ${({ theme }) => theme.colors.primary};
  background-color: transparent;
  border: 1.5px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.sizes.borderRadius};

  &:not(:disabled):hover {
    background-color: ${({ theme }) => theme.colors.primaryMuted};
  }
`;
